import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import unregister from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
/**
 * Register or unregister
 * turning off - causing cache issues in browser.
 */
// registerServiceWorker();
